module.exports = __webpack_public_path__ + "img/title.7bbeaace.png";